
<div class="anexos">
  <div class="anexos__area" (drop)="drop($event)" (dragover)="dragover($event)" (dragleave)="dragleave($event)" *ngIf="!options.hideUpload" [ngClass]="{'anexos__area--disabled': options.disableUpload}">
    <input type="file" name="" id="" multiple class="input" [accept]="acceptedFiles" (change)="loadFiles($event)">
    <mat-icon class="anexos__area__icon">attach_file</mat-icon>
    <div class="anexos__area__text">
      {{ options.disableUpload ? 'Envio de arquivos desabilitado' : 'Arraste e solte os arquivos aqui para fazer o upload' }}
    </div>
  </div>
  
  <mat-tab-group *ngIf="files.length > 0 || sentFiles.length > 0 ">
    <mat-tab label="Novos" *ngIf="!options.hideUpload">
      <div class="anexos__files" *ngIf="files.length > 0">
        <ng-container *ngFor="let file of files">
          <app-file [file]="file" [actions]="fileActions"></app-file>
        </ng-container>
      </div>
    </mat-tab>
    
    <mat-tab label="Enviados" *ngIf="!options.hideSent">
      <div class="anexos__files" *ngIf="sentFiles.length > 0">
        <ng-container *ngFor="let file of sentFiles">
          <app-file [file]="file" [actions]="fileSentActions"></app-file>
        </ng-container>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>